module.exports = __webpack_public_path__ + "static/media/5.60e42828.jpg";